import { z } from 'zod';

import { copy } from './copy';

/**
 * The two public fields, and they are the whole editable set for a
 * credential-less profile.
 *
 * No role field, and its absence is the rule rather than an omission: a role
 * belongs to the credit relation, not to the person, so it is edited on the
 * credit's own row.
 */
export const personFieldsSchema = z.object({
  displayName: z.string().trim().min(1, copy.fields.name.required),
  biography: z.string().trim(),
});

export type PersonFieldValues = z.output<typeof personFieldsSchema>;
export type PersonFieldInputs = z.input<typeof personFieldsSchema>;
